var React = require('react');

function IconLinkedIn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.768 1.488c0 .822-.661 1.488-1.476 1.488S.817 2.31.817 1.488 1.477 0 2.292 0s1.476.667 1.476 1.488zm.012 2.678H.805v9.522H3.78V4.166zm4.75 0H5.574v9.522h2.957V8.689c0-2.779 3.588-3.006 3.588 0v4.998h2.968V7.658c0-4.689-5.31-4.519-6.557-2.21V4.166z"}));
}

IconLinkedIn.defaultProps = {"width":"16","height":"14","fill":"#fff"};

module.exports = IconLinkedIn;

IconLinkedIn.default = IconLinkedIn;
